/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Contact form (Web3Forms) — see partials/components/contact-form.hbs */
(function () {
    const form = document.querySelector('[data-contact-form]');
    if (!form) return;

    const status = form.querySelector('[data-contact-form-status]');
    const button = form.querySelector('.gh-contact-form__button');

    form.addEventListener('submit', function (event) {
        event.preventDefault();

        form.classList.remove('success', 'error');
        form.classList.add('loading');
        if (button) button.disabled = true;
        if (status) status.textContent = '';

        const data = Object.fromEntries(new FormData(form));

        fetch('https://api.web3forms.com/submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                form.classList.remove('loading');
                if (button) button.disabled = false;

                if (result.success) {
                    form.classList.add('success');
                    form.reset();
                    if (status) status.textContent = 'Thanks — your message has been sent.';
                } else {
                    form.classList.add('error');
                    if (status) status.textContent = result.message || 'Something went wrong. Please try again.';
                }
            })
            .catch(function () {
                form.classList.remove('loading');
                form.classList.add('error');
                if (button) button.disabled = false;
                if (status) status.textContent = 'Something went wrong. Please try again.';
            });
    });
})();

/* Events: order + split by the date in each post title.
   Titles use the dispatch date format, e.g. "Sunday, 26 April 2026."
   - Home (.gh-grid-section__inner[data-events-order]): one flat list, sorted.
   - Events tag page: cards distributed into Upcoming (today or later) and
     Past (before today), with empty sections hidden. */
(function () {
    const MONTHS = {
        january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
        july: 6, august: 7, september: 8, october: 9, november: 10, december: 11
    };

    function parseEventDate(text) {
        if (!text) return null;
        // Drop ordinal suffixes ("6th" -> "6") so both date styles parse
        const t = text.replace(/(\d+)(st|nd|rd|th)/gi, '$1');

        // "<day> <month> <year>"  e.g. "Sunday, 26 April 2026." (dispatch format)
        const dmy = t.match(/(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})/);
        if (dmy && MONTHS[dmy[2].toLowerCase()] != null) {
            return new Date(parseInt(dmy[3], 10), MONTHS[dmy[2].toLowerCase()], parseInt(dmy[1], 10));
        }

        // "<month> <day>, <year>"  e.g. "July 6, 2026"
        const mdy = t.match(/([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})/);
        if (mdy && MONTHS[mdy[1].toLowerCase()] != null) {
            return new Date(parseInt(mdy[3], 10), MONTHS[mdy[1].toLowerCase()], parseInt(mdy[2], 10));
        }

        // Fallback: let the browser try
        const d = new Date(t.replace(/^[A-Za-z]+,\s*/, '').replace(/\.$/, ''));
        return isNaN(d.getTime()) ? null : d;
    }

    function cellDate(cell) {
        // Prefer the title (the intended location), fall back to the subheader
        const header = cell.querySelector('.gh-article-card__header');
        const sub = cell.querySelector('.gh-article-card__subheader');
        return parseEventDate(header && header.textContent) || parseEventDate(sub && sub.textContent);
    }

    const EPOCH = new Date(0);

    /* Home: flat, ordered list */
    document.querySelectorAll('[data-events-order]').forEach(function (container) {
        const dir = container.getAttribute('data-events-order') === 'desc' ? -1 : 1;
        Array.prototype.slice.call(container.querySelectorAll('[data-event-cell]'))
            .map(function (cell) { return { cell: cell, date: cellDate(cell) || EPOCH }; })
            .sort(function (a, b) { return (a.date - b.date) * dir; })
            .forEach(function (o) { container.appendChild(o.cell); });
    });

    /* Events tag page: split into upcoming / past */
    const source = document.querySelector('[data-events-source]');
    const upcoming = document.querySelector('[data-events-upcoming]');
    const past = document.querySelector('[data-events-past]');

    if (source && upcoming && past) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const up = [];
        const pa = [];

        Array.prototype.slice.call(source.querySelectorAll('[data-event-cell]')).forEach(function (cell) {
            const date = cellDate(cell);
            if (date && date.getTime() >= today.getTime()) {
                up.push({ cell: cell, date: date });
            } else {
                pa.push({ cell: cell, date: date || EPOCH });
            }
        });

        up.sort(function (a, b) { return a.date - b.date; });   // soonest first
        pa.sort(function (a, b) { return b.date - a.date; });   // most recent first

        up.forEach(function (o) { upcoming.appendChild(o.cell); });
        pa.forEach(function (o) { past.appendChild(o.cell); });

        function show(selector) {
            const el = document.querySelector(selector);
            if (el) el.style.display = '';
        }

        if (up.length) show('[data-events-upcoming-section]');
        if (pa.length) show('[data-events-past-section]');
        if (!up.length && !pa.length) show('[data-events-empty]');

        source.parentNode.removeChild(source);
    }
})();

/* Align card titles within each grid section.
   Cards anchor their text to the bottom of the cell, so a title/subtitle that
   wraps to more lines starts higher up than its neighbours. After the natural
   layout (and after the events cards above have been distributed), measure each
   card's text block, find the tallest in the grid, and pad the shorter ones up
   to match — every title then starts at the same height, and on pages where all
   titles wrap alike nothing moves at all. Re-measures when the web fonts arrive
   and on resize, since both change how titles wrap. */
(function () {
    const BLOCKS = '.gh-article-card__inner, .gh-book-card__meta';

    function measure(block) {
        const first = block.firstElementChild;
        const last = block.lastElementChild;
        if (!first) return 0;
        return last.getBoundingClientRect().bottom - first.getBoundingClientRect().top;
    }

    function align() {
        const grids = [];

        // Read everything first, then write, so we only trigger one reflow
        document.querySelectorAll('.gh-grid-section__inner').forEach(function (grid) {
            const blocks = Array.prototype.slice.call(grid.querySelectorAll(BLOCKS));
            if (!blocks.length) return;

            const entries = blocks.map(function (block) {
                // The stylesheet padding, captured before any inline override
                if (!block.dataset.alignBasePad) {
                    block.dataset.alignBasePad = parseFloat(getComputedStyle(block).paddingBottom) || 0;
                }
                return { block: block, height: measure(block) };
            });

            grids.push(entries);
        });

        grids.forEach(function (entries) {
            const max = Math.max.apply(null, entries.map(function (e) { return e.height; }));
            entries.forEach(function (e) {
                const pad = parseFloat(e.block.dataset.alignBasePad) + max - e.height;
                e.block.style.paddingBottom = pad + 'px';
            });
        });
    }

    if (!document.querySelector(BLOCKS)) return;

    align();

    // Font metrics change line wrapping, so re-run once the web fonts are in
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(align);
    }

    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(align, 150);
    });
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();